import Image from '../Image/Image';
import { OptionItemInfoText } from '../OptionItem';
import OptionItem from '../OptionItem/OptionItem';

import styles from './NetworkOption.module.css';

export interface NetworkOptionProps {
  className?: string;
  networkName: string;
  description?: string;
  loading?: boolean;
  disabled?: boolean;
  networkIconSrc?: string;
  infoText?: string;
  onClick: () => void;
}

export default function NetworkOption({
  className,
  networkName,
  infoText,
  description,
  networkIconSrc,
  ...otherProps
}: NetworkOptionProps): JSX.Element {
  return (
    <OptionItem
      {...otherProps}
      dataTestId="network-option-item"
      name={networkName}
      description={description}
      icon={
        <div className={styles['icon-wrapper']}>
          <Image src={networkIconSrc} alt={networkName} />
        </div>
      }
      disabled={otherProps.disabled}
      rightBottomSlot={infoText && <OptionItemInfoText text={infoText} />}
    />
  );
}
